import HomeIcon from '@mui/icons-material/Home';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import FeedIcon from '@mui/icons-material/Feed';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import EventNoteIcon from '@mui/icons-material/EventNote';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import FmdBadIcon from '@mui/icons-material/FmdBad';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import LockIcon from '@mui/icons-material/Lock';

export const SideBarData=[
    {
        id:1,
        imgComponent:HomeIcon,
        text:'Dash board',
        link:''
    },
    {
        id:2,
        imgComponent:FormatListBulletedIcon,
        text:'Result',
        link:'Result'
    },
    {
        id:3,
        imgComponent:FeedIcon,
        text:'Course Registration',
        link:'CourseReg'
    },
    {
        id:4,
        imgComponent:FeedIcon,
        text:'Registered Courses',
        link:'RegisteredCourse'
    },
    {
        id:5,
        imgComponent:AccountBalanceIcon,
        text:'Department',
        link:'Department'
    },
    {
        id:6,
        imgComponent:FileCopyIcon,
        text:'Resource',
        link:'Resource'
    },
    {
        id:7,
        imgComponent:CalendarTodayIcon,
        text:'Lecture Timetable',
        link:'LectureTimetable'
    },
    {
        id:8,
        imgComponent:EventNoteIcon,
        text:'School Calendar',
        link:'SchoolCalendar'
    },
    {
        id:9,
        imgComponent:FmdBadIcon,
        text:'Missed Session',
        link:'MissedSession'
    },
    {
        id:10,
        imgComponent:ForwardToInboxIcon,
        text:'Portal Feedback',
        link:'PortalFeedback'
    },
    {
        id:11,
        imgComponent:LockIcon,
        text:'Change Password',
        link:'ChangePassword'
    },
]